import React, { Component } from 'react';

import { track } from '../../../utils/analytics';

import style from './index.module.scss';

export default class ArchetypesMenu extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hovered: false
    }

    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
  }

  handleMouseEnter() {
    track('visible', `Archetype menu expanded`);
    this.setState(() => ({ hovered: true }));
  }

  handleMouseLeave() {
    this.setState(() => ({ hovered: false }));
  }

  render() {
    const { useUnderline, archetypes, onArchetypeChange, result, color } = this.props;
    const { hovered } = this.state;

    return (
      <div className={`${style.menu} ${hovered ? style.hovered : ''}`} style={{ color }} onMouseEnter={this.handleMouseEnter} onMouseLeave={this.handleMouseLeave}>
      <div className={`${style['results-menu']} ${!hovered ? style.active : ''}`}>The Personas</div>
        <div className={`${style.options}`}>
          {archetypes.map((archetype, index) => <div className={`${style['results-menu-item']} ${result === index ? style.active : ''}`} style={{ color: 'black'}} onClick={onArchetypeChange.bind(this, index)} key={`archetype-${index}`}>{archetype.personaNameLong}</div>)}
        </div>
        { useUnderline ? <div className={style.underline} style={{ background: color }} /> : null }
      </div>
    )
  }
}

ArchetypesMenu.defaultProps = {
  useUnderline: true
}
